import TechnologyList from "./TechnologyList.container";

export default TechnologyList;
